import React, { FC } from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Modules, useModule } from '@hooks/useModule';
import styles from './Rating.module.css';

export interface RatingFormProps {
    rating?: number;
    reviews?: number;
}

export const Rating: FC<RatingFormProps> = ({ rating, reviews }) => {
    const { isModuleActive } = useModule();

    return (
        <>
            {isModuleActive(Modules.rating) ? (
                <div className="mb-2 mb-md-3">
                    <>
                        {[0, 1, 2, 3, 4].map((item) => {
                            return rating && item < rating ? (
                                <Typography classes="d-inline-block">
                                    <i className={`${styles['filled-star']} fa-solid fa-star`} key={`solid-${item}`} />
                                </Typography>
                            ) : (
                                <Typography color="muted" classes="d-inline-block">
                                    <i className="fa-light fa-star" key={`light-${item}`} />
                                </Typography>
                            );
                        })}

                        <Typography classes="ms-2" color="muted" tagVariant={TypographyTagVariants.span}>
                            <>({reviews})</>
                        </Typography>
                    </>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};
